export default {
  propsDefault: {
    label: 'label',
    path: 'path',
    icon: 'icon',
    children: 'children',
    isOpen: 'isOpen'
  }
}



// WEBPACK FOOTER //
// ./src/components/sidebar/config.js